// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import 'jspdf-autotable';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Components-2/Header/Header';
import Sidebar1 from '../../Components-2/Sidebar1';
import { getApi } from '../Admin Master/Area Control/Zonemaster/ServicesApi';
import html2pdf from "html2pdf.js";
import logoimg from '../../Assets/Images/FutureInvoice.png';
import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { IoDocumentText } from "react-icons/io5";

function QuotationPdf() {

    const location = useLocation();
    const navigate = useNavigate();
    const fromPath = location?.state?.from || "/";
    const [quoData, setGetQuoData] = useState([]);
    const quoNo = location?.state?.quoNo || "";
    const tab = location?.state?.tab || "";
    const [loading, setLoading] = useState(true);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const pageRef = useRef();
    useEffect(() => {
        console.log(quoNo)
        const fetchData = async () => {
            try {
                const response = await getApi(`/PrintQuotation?QuotationNo=${quoNo}`);
                setGetQuoData(response?.data || {});
            } catch (err) {
                console.error('Fetch Error:', err);
            } finally {
                setLoading(false);
                setIsDataLoaded(true);
            }
        };
        if (quoNo) {
            fetchData();
        }
    }, []);


//     const generatePDF = () => {
//         if (!pageRef.current) return;

//         const element = pageRef.current;

//        const opt = {
//     margin: 10,

//     image: {
//         type: "jpeg",
//         quality: 1,
//     },

//     html2canvas: {
//         scale: 2,
//         useCORS: true,
//         scrollY: 0,
//         letterRendering: true,
//     },

//     jsPDF: {
//         unit: "mm",
//         format: "a4",
//         orientation: "portrait",
//     },

//     pagebreak:{
//     mode:["legacy"]
// }
// };

//         html2pdf()
//             .set(opt)
//             .from(element)
//             .save();
//     };

const generatePDF = async () => {
    if (!pageRef.current) return;

    // Save original margin
    const elements = document.querySelectorAll(".marginZero");
    elements.forEach(el => {
        el.dataset.originalMargin = el.style.marginTop;
        el.style.marginTop = "0px";
    });

    const opt = {
        margin: [10, 10, 10, 10],
        filename: `Quotation_${Date.now()}.pdf`,
        image: {
            type: "jpeg",
            quality: 1
        },
        html2canvas: {
            scale: 2.5,
            useCORS: true,
            allowTaint: true,
            scrollY: 0,
            windowWidth: document.documentElement.scrollWidth
        },
        jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "portrait"
        },
        pagebreak: {
            mode: ["css", "legacy"]
        }
    };

    await html2pdf()
        .set(opt)
        .from(pageRef.current)
        .save();

    // Restore original margin
    elements.forEach(el => {
        el.style.marginTop = el.dataset.originalMargin || "50px";
        delete el.dataset.originalMargin;
    });
};


    return (
        <>
            <style>
                {`
                @media print 
                {
    body * {
        visibility: hidden;
    }

    #pdf, #pdf * {
        visibility: visible;
    }

    #pdf {
        position: absolute;
        left: 0;
        top: 0;
        width: auto !important;
        padding: 0 !important;
        margin: 0 !important;
        box-sizing: border-box;
    }

    .container-2,
    .container-3,
    {
      border:none !important;
    }

    button {
        display: none !important;
    }

   
}

.custom-list {
    display: flex;
    flex-direction: column;
    gap: 0px;
}

.custom-list-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    line-height: 1.5;
    width: 100%;
               
}
    

.bullet{
     width: 18px; 
     font-size: 22px; 
     font-weight: bold; 
     line-height: 1.2; 
     text-align: center; 
     flex-shrink: 0; 
     margin-top: -2px; /* Adjust bullet alignment if needed */
}

.item-text{
    flex:1;
    white-space: normal;
}
   
`}
            </style>

            <Header />
            <Sidebar1 />
            <div id="main-body">

                <div style={{ borderRadius: "0px", width: "892px", height: "40px", border: "none" }}>

                    <div style={{ borderRadius: "0px", width: "892px", display: "flex", flexDirection: "row", border: "none", justifyContent: "end", gap: "10px", fontSize: "12px", alignItems: "center" }}>
                        <button
                            onClick={generatePDF}
                            style={{ padding: "5px 5px", borderRadius: "6px", background: "green", color: "white", border: "none", cursor: "pointer" }}
                        >
                            Download
                        </button>
                        <button
                            onClick={() => window.print()}
                            style={{ padding: "5px 10px", borderRadius: "6px", background: "red", color: "white", border: "none", cursor: "pointer" }}
                        >
                            Print
                        </button>



                        <button
                            onClick={() => navigate(fromPath, { state: { tab: tab } })}
                            style={{ padding: "5px 10px", borderRadius: "6px", background: "gray", color: "white", border: "none", cursor: "pointer" }}
                        >
                            Exit
                        </button>
                    </div>
                </div>

                <div className="container-2" style={{
                    borderRadius: "0px", paddingLeft: "20px", paddingRight: "20px", paddingTop: "20px", paddingBottom: "20px", width: "892px", direction: "flex",
                    flexDirection: "column", gap: "5px", fontFamily: '"Times New Roman", Times, serif',
                }}>

                    <div className="container-2" style={{ borderRadius: "0px", width: "850px", display: "flex", flexDirection: "column" }}>

                        < div id="printable-section" ref={pageRef} id="pdf" className="container-3" style={{ padding: "0px" ,fontFamily: "Arial, sans-serif",}}>
                            <div className="div1" style={{ width: "100%", display: "flex", flexDirection: "row",padding:"40px" }}>
                                <div style={{ width: "80%", display: "flex", gap: "7px" }}>
                                    <div style={{ width: "180px", height: "110px", padding: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
                                        <img src={logoimg} alt="" style={{ height: "100%", width: "100%", }} />
                                    </div>
                                    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                        <div style={{ fontWeight: "bold", color: "#00499c", fontSize: "16px", marginTop: "12px" }}>FUTURE INFOSYS TECHNOLOIES</div>
                                        <div >FL-203 PL-243 SEC-R3 SHREE KRISHNA KRUPA PANVEL RAIGAD VADGHAR (CT),
                                            Navi Mumbai - 410206</div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                fontSize: "12px",
                                                gap: "0px",
                                                width: "100%"

                                            }}
                                        >
                                            {
                                                [

                                                    {
                                                        no: <FaPhone />,
                                                        title: "Contact Us",
                                                        width: "30%",
                                                        lines: ["+91 9987355637", "+91 8591892930"],
                                                    },
                                                    {
                                                        no: <IoMdMail />,
                                                        title: "Email",
                                                        width: "40%",
                                                        lines: ["account@futureinfosys.in", "cs@futureinfosys.in"],
                                                    },

                                                    {
                                                        no: <IoDocumentText />,
                                                        title: "GSTIN",
                                                        width: "30%",
                                                        lines: ["27HQPS7651A1ZQ"],
                                                    },
                                                ].map((item, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "flex-start",
                                                            gap: "8px",
                                                            width: item.width,
                                                        }}
                                                    >


                                                        <div>
                                                            <div
                                                                style={{
                                                                    fontWeight: "bold",
                                                                    color: "#0b4ea2",
                                                                    marginBottom: "4px",
                                                                    display: "flex",
                                                                    gap: "5px",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        minWidth: "15px",
                                                                        height: "15px",
                                                                        borderRadius: "50%",
                                                                        background: "#0b4ea2",
                                                                        color: "#fff",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        fontSize: "8px",
                                                                    }}
                                                                >
                                                                    {item.no}
                                                                </div>
                                                                <span>{item.title}</span>
                                                            </div>

                                                            {item.lines.map((line, i) => (
                                                                <div key={i} style={{ fontSize: "11px", lineHeight: "1" }}>
                                                                    {line}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "20%", display: "flex", justifyContent: "end", }}>
                                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                        <div style={{ fontSize: "18px", color: "#00499c", fontWeight: "bold" }}>Quotation</div>
                                        <div style={{ color: "#00499c", fontWeight: "bold" }}>#QNO-{quoData?.QuotationHeader?.QuotationNo}</div>
                                        <div>Date : <span>{quoData?.QuotationHeader?.QuotationDate}</span></div>
                                    </div>
                                </div>

                            </div>
                            <div style={{height:"1px",borderTop:"1px solid gray",margin:"0px 45px"}}></div>
                            <div style={{ padding: "0px 100px",paddingBottom:"10px" }}>

                                <div

                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        fontWeight: 500,
                                        fontSize: "15px",
                                        fontFamily: "Arial, sans-serif",
                                        lineHeight: "1.8",
                                    }}
                                >

                                    <div style={{ marginTop: "20px" }}>To,</div>
                                    <div>{quoData?.CustomerDetails?.CustomerName}</div>
                                    <div>
                                        {quoData?.CustomerDetails?.Address1},
                                        {quoData?.CustomerDetails?.Address2},
                                        {quoData?.CustomerDetails?.Address3}
                                    </div>
                                    <div>Mobile: +91 {quoData?.CustomerDetails?.MobileNo}</div>

                                    <div
                                        style={{
                                            marginTop: "25px",
                                            fontWeight: "bold",
                                            color: "#123c72c3",
                                            fontSize: "17px",
                                        }}
                                    >
                                        Subject: Quotation for Courier & Logistics ERP Software Proposal
                                    </div>

                                    <div
                                        style={{
                                            marginTop: "0px",
                                            fontWeight: "bold",
                                            color: "#123c72c3",
                                            fontSize: "17px",
                                        }}
                                    >
                                        Windows Desktop + Cloud Base 
                                    </div>






                                    <div
                                        style={{
                                            marginTop: "25px",
                                            fontWeight: "bold",
                                            color: "#0d84d8",
                                            fontSize: "18px",
                                        }}
                                    >
                                        Complete Software Solution Includes
                                    </div>

                                    <div style={{ marginTop: "0px", color: "red", fontWeight: "bold", fontSize: "17px" }}>
                                        1.Windows Desktop Application
                                    </div>


                                    {/* Login Panel */}
                                    <div style={{ color: "#123c72c3", fontWeight: "bold", fontSize: "17px" }}>
                                        Login Panel
                                    </div>

                                    {/* Branch Master */}
                                    <div style={{ color: "#0d84d8", fontWeight: "bold" }}>
                                        User Control
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Admin Login",
                                            "Branch Login",
                                            "Customer Login",
                                            "Employee Login",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>
                                    {/* ================= Master Module ================= */}

                                    <div style={{ marginTop: "50px", color: "#123c72c3", fontWeight: "bold", fontSize: "17px" }}>
                                        Master Module
                                    </div>

                                    {/* Branch Master */}
                                    <div style={{ color: "#0d84d8", fontWeight: "bold" }}>
                                        Branch Master
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Branch Management",
                                            "Mode Master",
                                            "Bank Master",
                                            "Delivery Boy Master",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Customer Master */}
                                    <div style={{ marginTop: "15px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Customer Master
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Customer Registration",
                                            "Customer Rate Management",
                                            "Customer Charges",
                                            "ODA Charges",
                                            "Customer Volumetric",
                                            "Update Customer Rate",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Consignee Master */}
                                    <div style={{ marginTop: "15px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Consignee Master
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Receiver Management",
                                            "Shipper Management",
                                            "GST Charges",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Area Control */}
                                    <div style={{ marginTop: "15px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Area Control
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "City Master",
                                            "Multiple City",
                                            "State Master",
                                            "Country Master",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Vendor Master */}
                                    <div style={{ marginTop: "15px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Vendor Master
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Vendor Registration",
                                            "Vendor Rate",
                                            "Vendor Charges",
                                            "Fuel Charges",
                                            "GST Master",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Transport Master */}
                                    <div style={{ marginTop: "15px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Transport Master
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Vehicle Master",
                                            "Transport Company",
                                            "Driver Master",
                                            "Flight Master",
                                            "Train Master",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Stock Management */}
                                    <div style={{ marginTop: "15px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Stock Management
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Branch Stock",
                                            "Customer Stock",
                                            "Employee Stock",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Region Master */}
                                    <div style={{ marginTop: "15px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Region Master
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Region Management",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div style={{ marginTop: "50px", color: "#123c72c3", fontWeight: "bold", fontSize: "17px" }}>
                                        Operation Module
                                    </div>

                                    {/* Docket Booking */}
                                    <div style={{ fontWeight: "bold", color: "#0d84d8", }}>
                                        Docket Booking
                                    </div>

                                    <div className="custom-list">
    {[
        "Manual Booking",
        "Smart Booking",
        "Bulk Booking",
        "Docket Printing",
        "Cash To Pay Payment Received",
        "Auto Mail",
        "Performa Invoice",
        "International Forwarding",
        "Rate Calculator",
    ].map((item, index) => (
        <React.Fragment key={index}>

            {item === "Docket Printing" && (
                <div className="html2pdf__page-break"></div>
            )}

            <div className="custom-list-item">
                <span className="bullet">•</span>
                <span className="item-text">{item}</span>
            </div>

        </React.Fragment>
    ))}
</div>

                                    {/* Manifest Management */}
                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8", }}>
                                        Manifest Management
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Pending Manifest",
                                            "Outgoing Manifest",
                                            "View Manifest",
                                            "International Manifest",
                                            "Bulk Import Manifest",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Scan Process Hub */}
                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8", }}>
                                        Scan Process Hub
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Pending Scan",
                                            "Scan by Docket Number",
                                            "Inscan Process",
                                            "Inscan by DRS Number",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Run Sheet (DRS) */}
                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8", }}>
                                        Run Sheet (DRS)
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Delivery Pending",
                                            "Delivery Entry",
                                            "View DRS",
                                            "Import DRS",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Status Activity */}
                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8", }}>
                                        Status Activity
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Activity Entry",
                                            "Bulk Activity Upload",
                                            "Shipment Tracking",
                                            "Website Live Tracking",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* POD Record */}
                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8", }}>
                                        POD Record
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Delivered Entry",
                                            "Return Booking",
                                            "Bulk Excel Upload",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Docket Print */}
                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8", }}>
                                        Docket Print
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Delivery Print",
                                            "Label Printing",
                                            "Sticker Printing",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Status Upload */}
                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8", }}>
                                        Status Upload
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Status Upload",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Complaint Module */}
                                    <div className='marginZero' style={{ marginTop: "50px", color: "#123c72c3", fontWeight: "bold", fontSize: "17px" }}>
                                        Complaint Module
                                    </div>

                                    <div style={{ fontWeight: "bold", color: "#0d84d8" }}>
                                        Customer Complaint
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Customer Complaint",
                                            "Query Management",
                                            "Complaint Status",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Billing Module */}
                                    <div style={{ marginTop: "50px", color: "#123c72c3", fontWeight: "bold", fontSize: "17px" }}>
                                        Billing Module
                                    </div>

                                    <div style={{ fontWeight: "bold", color: "#0d84d8" }}>
                                        Invoice Management
                                    </div>


<div className="custom-list">
    {[
        "Pending Invoice",
        "Generate Invoice",
        "View Invoice",
        "GST File Data",
        "Performance Invoice",
        "View Performance Invoice",
    ].map((item, index) => (
        <React.Fragment key={index}>

            {/* View Performance Invoice se naya page */}
            {/* {item === "View Performance Invoice" && (
                <div className="html2pdf__page-break"></div>
            )} */}

            <div className="custom-list-item">
                <span className="bullet">•</span>
                <span className="item-text">{item}</span>
            </div>

        </React.Fragment>
    ))}
</div>
                                   

                                    {/* Payment Module */}
                                    <div style={{ marginTop: "50px", color: "#123c72c3", fontWeight: "bold", fontSize: "17px" }}>
                                        Payment Module
                                    </div>

                                    <div style={{ fontWeight: "bold", color: "#0d84d8" }}>
                                        Ledger
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Payment Received",
                                            "Outstanding Payment",
                                            "Credit Note",
                                            "Credit Booking",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Reports Module */}
                                    <div style={{ marginTop: "50px", color: "#123c72c3", fontWeight: "bold", fontSize: "17px" }}>
                                        Reports Module
                                    </div>

                                    <div style={{ fontWeight: "bold", color: "#0d84d8" }}>
                                        MIS Reports
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Booking MIS",
                                            "Vendor MIS",
                                            "Booking Mode Report",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8" }}>
                                        Booking Reports
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Booking Details",
                                            "Total Charges Report",
                                            "Mode Wise Report",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8" }}>
                                        Invoice Reports
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Invoice Ledger Report",
                                            "Checklist Report",
                                            "Unbilled Report",
                                            "Bill View Report",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="html2pdf__page-break"></div>
                                    {/* Technology */}
                                    <div className='marginZero' style={{ marginTop: "50px", color: "#123c72c3", fontWeight: "bold", fontSize: "17px" }}>
                                        Technology
                                    </div>

                                    <div style={{ fontWeight: "bold", color: "#0d84d8" }}>
                                        Windows Application
                                    </div>

                                   <div className="custom-list">
    {[
        "React",
        "Node Js",
        "SQL Server",
    ].map((item, index) => (
        <React.Fragment key={index}>

            {/* {item === "Node Js" && (
                <div className="html2pdf__page-break"></div>
            )} */}

            <div className="custom-list-item">
                <span className="bullet">•</span>
                <span className="item-text">{item}</span>
            </div>

        </React.Fragment>
    ))}
</div>

                                    <div style={{ marginTop: "15px", fontWeight: "bold", color: "#0d84d8" }}>
                                        Database
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Microsoft SQL Server",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Deliverables */}
                                    <div
                                        style={{
                                            marginTop: "50px",
                                            color: "#123c72c3",
                                            fontWeight: "bold",
                                            fontSize: "17px",
                                        }}
                                    >
                                        Deliverables
                                    </div>

                                    <div style={{ fontWeight: "bold", color: "#0d84d8" }}>
                                        Deliverables
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Windows Desktop Software",
                                            "Admin Panel",
                                            "Branch Panel",
                                            "API Integration",
                                            "Database Setup",
                                            "User Training",
                                            "Technical Support",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet" style={{ fontWeight: "normal", }}>✔</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div
                                        style={{
                                            marginTop: "25px",
                                            fontWeight: "bold",
                                            color: "red",
                                            fontSize: "18px",
                                        }}
                                    >
                                        2.Commercial Proposal
                                    </div>

                                    <div>
                                        Custom Software Development (End-to-End):
                                        <strong> Rs. {quoData?.Description?.[0]?.Amount}/-</strong>
                                    </div>

                                    <div>
                                        Total Project Value:
                                        <strong> Rs. {quoData?.Description?.[0]?.Amount}/-</strong>
                                    </div>

                                    <div>
                                        Note: <strong>GST Extra as applicable.</strong>
                                    </div>

                                    <div
                                        style={{
                                            marginTop: "25px",
                                            fontWeight: "bold",
                                            color: "red",
                                            fontSize: "18px",
                                        }}
                                    >
                                        3.Timeline & Payment Terms
                                    </div>

                                    <div>Estimated Delivery: <strong>7–30 Working Days</strong></div>
                                    <div>50% Advance Payment: <strong>Rs. {quoData?.Description?.[0]?.Amount / 2}/-</strong></div>
                                    <div>50% Balance Payment Upon UAT & Handover: <strong>Rs. {quoData?.Description?.[0]?.Amount / 2}/-</strong></div>

                                    <div>Vendor Tracking API Development Cost <strong>(Rs. 2,000/-)</strong>  Per Single Vendor</div>
                                    <div>Client agrees to pay 50% Advance <strong>(Rs. {quoData?.Description?.[0]?.Amount / 2}/-)</strong> before project start.
                                    </div>


                                    {/* ================= AMC ================= */}

                                    <div style={{
                                        marginTop: "25px",
                                        fontWeight: "bold",
                                        color: "red",
                                        fontSize: "18px",
                                    }}>
                                        4. Annual Maintenance Contract (AMC)
                                    </div>

                                    <div style={{ marginTop: "10px" }}>
                                        The Annual Maintenance Contract (AMC) will commence after the completion of the
                                        <strong> 3 Months Free Technical Support</strong> period.
                                    </div>

                                    {/* AMC Charges */}

                                     <div className="html2pdf__page-break"></div>

                                    <div style={{ marginTop: "20px", color: "#0d84d8", fontWeight: "bold" }}>
                                        AMC Charges
                                    </div>

                                    <table
                                        style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                            marginTop: "10px",
                                            fontSize: "14px",
                                        }}
                                    >
                                        <thead>
                                            <tr>
                                                <th style={{ border: "1px solid #000", padding: "4px 10px", textAlign: "left" }}>
                                                    Description
                                                </th>
                                                <th style={{ border: "1px solid #000", padding: "4px 10px", textAlign: "left" }}>
                                                    Amount
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ border: "1px solid #000", padding: "4px 10px", }}>
                                                    Annual Maintenance Contract (AMC)
                                                </td>
                                                <td style={{ border: "1px solid #000", padding: "4px 10px", }}>
                                                    ₹5,999/- Per Year
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* AMC Includes */}

                                    <div style={{ marginTop: "20px", color: "#0d84d8", fontWeight: "bold" }}>
                                        AMC Includes
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Technical Support (Phone, WhatsApp & Remote Assistance)",
                                            "Software Bug Fixes",
                                            "Minor Feature Improvements",
                                            "Database Maintenance & Optimization",
                                            "Performance Monitoring",
                                            "Security Updates",
                                            "Backup Assistance",
                                            "Server Health Monitoring",
                                            "Remote Troubleshooting",
                                            "User Guidance & Assistance",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet" style={{ fontWeight: "normal" }}>✔</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Cloud Hosting */}

                                    <div style={{ marginTop: "20px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Cloud Hosting Features
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "20 GB High-Speed SSD Cloud Storage",
                                            "8 GB Dedicated RAM",
                                            "High Performance Multi-Core Processor",
                                            "Secure Cloud Hosting Environment",
                                            "Daily Automated Database Backup",
                                            "99.9% Server Uptime",
                                            "SSL Certificate Enabled",
                                            "API Hosting & Integration Support",
                                            "Windows ERP & Mobile App Synchronization",
                                            "Remote Access from Anywhere",
                                            "Automatic Backup & Restore",
                                            "High-Speed Network Connectivity",
                                            "Enterprise-Level Data Security",
                                            "Server Monitoring & Maintenance",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet" style={{ fontWeight: "normal" }}>✔</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Support Policy */}

                                    <div style={{ marginTop: "20px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Support & Hosting Policy
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "First 3 Months: FREE Technical Support + FREE Cloud Hosting",
                                            "From 4th Month Onwards: ₹1,000/- Per Month (Cloud Hosting & Server)",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet">•</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Website Package */}

                                    <div style={{
                                        marginTop: "25px",
                                        fontWeight: "bold",
                                        color: 'red',
                                        fontSize: "18px",
                                    }}>
                                        5. Website Design Packages
                                    </div>

                                    <div style={{ marginTop: "10px" }}>
                                        Website Design – A modern, responsive website compatible with desktop,
                                        tablet, and mobile devices.
                                    </div>

                                     <div className="html2pdf__page-break"></div>

                                    <div style={{ marginTop: "20px", color: "#0d84d8", fontWeight: "bold" }}>
                                        Included Features
                                    </div>

                                    <div className="custom-list">
                                        {[
                                            "Modern UI/UX Design",
                                            "Responsive Design (Mobile, Tablet & Desktop)",
                                            "Home Page",
                                            "About Us",
                                            "Services",
                                            "Gallery",
                                            "Tracking Page (if required)",
                                            "Contact Us",
                                            "Inquiry Form",
                                            "Google Maps Integration",
                                            "WhatsApp Chat Integration",
                                            "Social Media Links",
                                            "SSL Support",
                                            "Contact Form",
                                        ].map((item, index) => (
                                            <div className="custom-list-item" key={index}>
                                                <span className="bullet" style={{ fontWeight: "normal" }}>✔</span>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Website Price */}

                                    <table
                                        style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                            marginTop: "15px",
                                            fontSize: "14px",
                                        }}
                                    >
                                        <thead>
                                            <tr>
                                                <th style={{ border: "1px solid #000", padding: "4px 10px" }}>Package</th>
                                                <th style={{ border: "1px solid #000", padding: "4px 10px" }}>Features</th>
                                                <th style={{ border: "1px solid #000", padding: "4px 10px" }}>Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ border: "1px solid #000", padding: "4px 10px" }}>
                                                    Basic Website
                                                </td>
                                                <td style={{ border: "1px solid #000", padding: "4px 10px" }}>
                                                    Up to 5 Pages, Responsive Design, Contact Form, WhatsApp Chat,
                                                    Google Map, Basic SEO
                                                </td>
                                                <td style={{ border: "1px solid #000", padding: "4px 10px" }}>
                                                    ₹5,999/-
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div style={{ marginTop: "20px" }}>
                                        <strong>Note:</strong> The monthly cloud hosting charge includes server
                                        maintenance, database hosting, backups, security updates, SSL management,
                                        and technical monitoring to ensure smooth and secure operation of the
                                        Courier ERP system.
                                    </div>

                                    <div style={{ marginTop: "30px" }}>
                                        Advance Payment Received: ____________________________
                                    </div>

                                    <div style={{ marginTop: "5px" }}>
                                        Client Signature: _________________________________
                                    </div>

                                    <div style={{ marginTop: "5px" }}>
                                        Date: ___________________________________________
                                    </div>

                                    <div style={{ marginTop: "5px" }}>
                                        Company Stamp: _________________________________
                                    </div>

                                    <div style={{ marginTop: "30px" }}>
                                        We look forward to working with
                                        <strong> {quoData?.CustomerDetails?.CustomerName}</strong> to digitize and
                                        optimize your operations.
                                    </div>

                                    <div style={{ marginTop: "25px" }}>
                                        <strong>Warm Regards,</strong>
                                    </div>

                                    <div style={{ fontWeight: "bold" }}>
                                        Future Infosys Technology
                                    </div>

                                    <div style={{ fontStyle: "italic" }}>
                                        Empowering Logistics through Innovation
                                    </div>
                                </div>



                            </div>
                        </div >
                    </div>
                </div>


            </div >
        </>
    );
}

export default QuotationPdf;